export default "__VITE_ASSET__02610d21__"